export enum SortType {
    Default,
    NewestOnTop,
    OldestOnTop,
}
